import React from "react";
import PropTypes from "prop-types";
import {setupOnExtractData} from "../../../util/FormUtil";
import HasBrokerInputComponent, {PROP_NAME_HAS_BROKER} from "../input/HasBrokerInputComponent";
import {PROP_NAME_JOB_ROLE} from "../input/AboutYouInputComponent";
import {PROP_NAME_TRADES_FUTURES, PROP_NAME_TRADES_OPTIONS_ON_FUTURES} from "../input/TradeClearInputComponent";

class HasBrokerComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setExtractData = this.setExtractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    setExtractData(func){
        this.extractData = func;
    }

    render(){
        const {data, metadata, setFormState, userDataInit} = this.props;
        let displayHasBrokerQuestion = data[PROP_NAME_JOB_ROLE] === 'Independent Trader/Investor' &&
                                        (data[PROP_NAME_TRADES_FUTURES] === true ||
                                            data[PROP_NAME_TRADES_OPTIONS_ON_FUTURES] === true);
        if(displayHasBrokerQuestion) {
            setupOnExtractData(this);
            return (
                <div className="grid">
                    <div className="grid__col-md-3 grid__col-sm-12">
                        Do you have a broker?
                    </div>
                    <div className="grid__col-md-9 grid__col-sm-12">
                        <HasBrokerInputComponent
                            data={data}
                            metadata={metadata}
                            setFormState={setFormState}
                            userDataInit={userDataInit}
                            onExtractData={this.setExtractData}
                        />
                    </div>
                </div>
            );
        }else{
            return ("");
        }
    }
}

HasBrokerComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    onExtractData: PropTypes.func
};

export default HasBrokerComponent;